import { TreeSelectionKeys } from 'primevue/tree';

/**
 * Parse selection keys into array of keys.
 *
 * @param nodeKeys - A collection of selected node keys.
 * @param includeNodeAllKey - Whether to include the "-1" key (representing "All").
 */
export const parseNodeKeys = (
  nodeKeys: TreeSelectionKeys,
  includeNodeAllKey = false,
): number[] => {
  return Object.keys(filterNodeKeys(nodeKeys, includeNodeAllKey)).map(Number);
};

/**
 * Filters a collection of selected node keys based on specific criteria.
 *
 * @param nodeKeys - A collection of selected node keys.
 * @param includeNodeAllKey - Whether to include the "-1" key (representing "All").
 * @returns A new collection of filtered node keys.
 */
export const filterNodeKeys = (
  nodeKeys: TreeSelectionKeys,
  includeNodeAllKey = false,
): TreeSelectionKeys => {
  return Object.fromEntries(
    Object.entries(nodeKeys).filter(([key, value]) => {
      // Only include nodes with checked: true and partialChecked: false
      const isNodeChecked = value.checked && !value.partialChecked;

      // Include the "-1" key if includeNodeAllKey is true
      const shouldIncludeNode = includeNodeAllKey || key != '-1';

      return isNodeChecked && shouldIncludeNode;
    }),
  );
};
